export default "https://cdn-static.gokick.com/assets/a067049b7600101c8dd9c58c97ab0ac81c37d227/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";